import getClassifiedsSite from 'utils/getClassifiedsSite';
import { AUTOCAR, AUTOCARUTMLINKS, WHATCARUTMLINKS } from './utm.links';

export const formatExternalLink = ({ link = '', network, gcLid }) => {
  const classifiedsSite = getClassifiedsSite();
  const isAutoCar = classifiedsSite && classifiedsSite === AUTOCAR;
  let qsArr = isAutoCar ? AUTOCARUTMLINKS : WHATCARUTMLINKS;

  if (network) {
    qsArr.push(`network=${network}`);
  }

  if (gcLid) {
    qsArr.push(`gclid=${gcLid}`);
  }

  return qsArr.length > 0 ? `${link}?${qsArr.join('&')}` : link;
};



// WEBPACK FOOTER //
// ./src/utils/utmLinks/index.js